import React, { useState } from 'react';
import './ConsumerVision2035.css';

const ConsumerVision2035 = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    source_page: window.location.pathname,
    consentTerms: false,
    consentMarketing: false,
    consentPrivacy: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [errors, setErrors] = useState({});


  const validateEmail = (email) => {
    const personalDomains = ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com', 'live.com', 'icloud.com'];
    const domain = email.split('@')[1]?.toLowerCase();
    return !personalDomains.includes(domain);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Nombre es requerido';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email es requerido';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Por favor usa tu email corporativo';
    }

    if (!formData.company.trim()) {
      newErrors.company = 'Empresa es requerida';
    }

    if (!formData.consentTerms) {
      newErrors.consentTerms = 'Debes aceptar los términos y condiciones';
    }

    if (!formData.consentPrivacy) {
      newErrors.consentPrivacy = 'Debes aceptar la privacidad de datos';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error when user starts typing/changing
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    setIsSubmitting(true);

    // Small delay for better UX
    setTimeout(() => {
      setSubmitSuccess(true);

      // GTM Event for analytics
      if (window.gtag) {
        window.gtag('event', 'consumer_vision_download', {
          event_category: 'Content Download',
          event_label: 'Consumer Vision 2035'
        });
      }

      // Trigger PDF download immediately
      const pdfUrl = '/downloads/dentsuDayCL_Consumer_Vision_2035-Global_Edition.pdf';
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'dentsuDayCL_Consumer_Vision_2035-Global_Edition.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setIsSubmitting(false);
    }, 500);
  };

  if (submitSuccess) {
    return (
      <div className="consumer-vision-page">
        <div className="cv-container">
          <div className="cv-success">
            <div className="success-icon">✓</div>
            <h2>¡Gracias por tu interés!</h2>
            <p>La descarga del Consumer Vision 2035 comenzó automáticamente.</p>
            <p>Si no se descarga automáticamente, <a href="/downloads/dentsuDayCL_Consumer_Vision_2035-Global_Edition.pdf" download>haz clic aquí</a>.</p>
            <button
              className="cv-btn-secondary"
              onClick={() => window.location.href = '/'}
            >
              Volver al evento
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="consumer-vision-page">
      <div className="cv-container">
        <div className="cv-content">
          <div className="cv-header">
            <div className="cv-logo">
              <img src="/images/hero/dentsu-day.svg" alt="Dentsu Day" className="cv-logo-img" />
            </div>
            <h1 className="cv-title">Consumer Vision 2035</h1>
            <div className="cv-subtitle">
              El futuro del comportamiento del consumidor ya está aquí
            </div>
          </div>

          <div className="cv-main">
            <div className="cv-info">
              <div className="cv-description">
                <p>
                  Hablamos con <strong>30.000 consumidores</strong> y <strong>20 expertos</strong> para identificar las 4 fuerzas que están transformando la tecnología, la cultura, el comportamiento de los consumidores y la manera en que las marcas se preparan para el futuro en los próximos 10 años y más.
                </p>
                <p>
                  Para tener éxito en la década de 2030, las marcas deberán pasar de enfocarse solo en el insight a desarrollar verdadera <strong>visión de futuro</strong>, ofreciendo a las personas soluciones emocionales e instintivas. En un mundo filtrado por la inteligencia artificial y moldeado por nuevos códigos culturales, esto será lo que determine no solo si los consumidores prefieren una marca, sino incluso si llegan a verla en su radar.
                </p>
              </div>

            </div>

            <div className="cv-form-section">
              <form onSubmit={handleSubmit} className="cv-form">
                <h3>Descarga el reporte completo</h3>



                <div className="cv-form-group">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Nombre *"
                    className={errors.name ? 'error' : ''}
                    required
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>

                <div className="cv-form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email *"
                    className={errors.email ? 'error' : ''}
                    required
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                <div className="cv-form-group">
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    placeholder="Empresa *"
                    className={errors.company ? 'error' : ''}
                    required
                  />
                  {errors.company && <span className="error-message">{errors.company}</span>}
                </div>

                {/* Hidden field for source page tracking */}
                <input
                  type="hidden"
                  name="source_page"
                  value={formData.source_page}
                />

                <div className="cv-form-group">
                  <label className={`cv-checkbox-label ${errors.consentTerms ? 'error' : ''}`}>
                    <input
                      type="checkbox"
                      name="consentTerms"
                      checked={formData.consentTerms}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="checkmark"></span>
                    Estoy de acuerdo con los <a href="https://www.iprospect.cl/files/Privacidad-de-datos-q.pdf" target="_blank" rel="noopener noreferrer" className="cv-link-button">términos y condiciones</a> *
                  </label>
                  {errors.consentTerms && <span className="error-message">{errors.consentTerms}</span>}
                </div>

                <div className="cv-form-group">
                  <label className="cv-checkbox-label">
                    <input
                      type="checkbox"
                      name="consentMarketing"
                      checked={formData.consentMarketing}
                      onChange={handleInputChange}
                    />
                    <span className="checkmark"></span>
                    Acepto recibir información de dentsu
                  </label>
                </div>

                <div className="cv-form-group">
                  <label className={`cv-checkbox-label ${errors.consentPrivacy ? 'error' : ''}`}>
                    <input
                      type="checkbox"
                      name="consentPrivacy"
                      checked={formData.consentPrivacy}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="checkmark"></span>
                    Acepto la <a href="https://www.iprospect.cl/files/Privacidad-de-datos-q.pdf" target="_blank" rel="noopener noreferrer" className="cv-link-button">privacidad de datos</a> *
                  </label>
                  {errors.consentPrivacy && <span className="error-message">{errors.consentPrivacy}</span>}
                </div>

                <button
                  type="submit"
                  className="cv-btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Descargar Consumer Vision 2035'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsumerVision2035;